import React from 'react'
import {AppWrapper, FunnelPage} from '@influxdata/clockface'

import LogoWithCubo from 'js/components/LogoWithCubo'

import FunnelPlans from './FunnelPlans'
interface Props {
  influxdbURL: string
}

const Plans = ({influxdbURL}: Props): JSX.Element => {
  return (
    <AppWrapper>
      <FunnelPage logo={<LogoWithCubo />}>
        <FunnelPlans influxdbURL={influxdbURL} />
      </FunnelPage>
    </AppWrapper>
  )
}

export default Plans
